module.exports = __webpack_public_path__ + "img/profile_box_coach_use_reasons.8ff7b2ba.svg";